import React, { Component } from 'react'
import { Paper, Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'

import TookanEmployeeInfoItem from './TookanEmployeeInfoItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'

const TookanEmployeeInfoItemEditable = EditableHOCWrapper(TookanEmployeeInfoItem)

export default class TookanEmployeeInfo extends Component {
  render() {
    const {
      employeeList = [],
      teamList = [],
      linkItem = () => {},
      removeWorker = () => {},
      lastModified,
      shopsList = {},
      tookanTeamList = [],
    } = this.props

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee</TableCell>
                    <TableCell>Team</TableCell>
                    <TableCell>Agent Id</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employeeList.map((employee) => (
                    <TookanEmployeeInfoItemEditable
                      key={employee.id}
                      dataToEdit={employee}
                      teamList={teamList}
                      linkItem={linkItem}
                      lastModified={lastModified}
                      removeWorker={removeWorker}
                      shopsList={shopsList}
                      tookanTeamList={tookanTeamList}
                    />
                  ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanEmployeeInfo.js